<template>
  <div class="wrap">
    <div class="login-box">
      <img class="logo" src="@/assets/images/logo-horizontal.png" />
      <div v-if="loginStatus == 2" class="login-title">
        <div class="tt">鹰眼管理系统登录</div>
        <div class="tt-en">EAGLE EYE SYSTEM LOGIN</div>
      </div>
      <div v-if="loginStatus == 3" class="login-title">
        <div class="tt">绑定手机号码</div>
        <div class="tt-en">BIND USER MOBILE</div>
      </div>
      <login-by-qrcode v-if="loginStatus == 2" />
      <login-bind-mobile v-if="loginStatus == 3" />
    </div>
  </div>
</template>

<script>
import loginBindMobile from './components/login-bind-mobile';
import loginByQrcode from './components/login-by-qrcode';
export default {
  components: { loginBindMobile, loginByQrcode },

  data() {
    return {
      title: process.env.VUE_APP_TITLE,
      loginStatus: 0, //1已登录 2未登录 3已登录未绑定手机号码
      loading: false,
    };
  },

  provide() {
    return {
      redirectProject: this.redirectProject,
      getLoginStatus: this.getLoginStatus,
    };
  },

  created() {
    this.getLoginStatus();
  },

  methods: {
    async getLoginStatus() {
      try {
        this.loginStatus = await this.$store.dispatch('user/updateLoginStatus');
        if (this.loginStatus == 1) {
          this.redirectProject();
        }
        return this.loginStatus;
      } catch (e) {
        console.error(e);
      }
    },

    redirectProject() {
      if (!this.$route.query.forward) {
        this.$router.replace('/map');
      } else {
        window.location.href = decodeURIComponent(this.$route.query.forward);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.wrap {
  height: 100vh;
  background: url('../../assets/images/login-bg.png') no-repeat center;
  background-size: cover;
  position: relative;
}

.login-box {
  width: 880px;
  height: 480px;
  position: absolute;
  border-radius: 6px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: left center;
  background-image: url('../../assets/images/login-box-bg.png');
  background-size: auto 100%;
}

.logo {
  position: absolute;
  display: block;
  top: 40px;
  left: 40px;
  width: 180px;
}

.login-title {
  position: absolute;
  top: 40px;
  left: 420px;
  text-align: center;
  width: 458px;

  .tt {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 3px;
  }

  .tt-en {
    font-size: 16px;
    color: #999;
  }
}
</style>
